import axios from 'axios';
import authHeader from './auth-header';
import CommonServices from './common.service';

const API_URL = CommonServices.getApiUrl() + 'holiday/';

class HolidayService {

  getHolidays(from, to) {
    return axios.get(API_URL, { headers: authHeader(),
      params: {
         from,
         to}
       });
  }

  saveHoliday(holiday) {
    if (holiday.id){
      return axios.put(API_URL+holiday.id, holiday, { headers: authHeader() });
    } else {
      return axios.post(API_URL, holiday, { headers: authHeader() });
    }
  }

  deleteHoliday(id) {
    return axios.delete(API_URL+id, { headers: authHeader() });
  }
}

export default new HolidayService();
